/**
 * @name: 开发者用户逻辑处理
 * @param {
 *  props: 创建编辑信息
 *  id：操作对象id
 *  emit
 * }
 * @return  创建，编辑，停用，启用，操作记录
 */
import { ref, getCurrentInstance } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';

import { IUserInfoItem, IUserInfoLogs } from '@/api/manage-app/user-info/index.d';
import {
  UpdateEnableUserInfo,
  DelUserInfoApi,
  AddUserInfo,
  EditUserInfo,
  UserInfoLogs,
  UserInfoRefreshWorkState,
} from '@/api/manage-app/user-info';

import { getAccountList } from '@/api/manage-app/account-info';
import { GetV1AccountInfoApiResItem } from '@/api/manage-app/account-info/index.d';

import { useAccountStore } from '@/store/account/index';

export const _CreatedUser = (
  props = {} as any,
  emit = '' as any,
) => {
  const accountStore = useAccountStore();
  const companyId = accountStore.currentCompany?.companyId ?? '';
  const currentInstance = getCurrentInstance()!;
  const accountUserItem = ref<Partial<IUserInfoItem>>({});
  // 编辑
  const createdUserVisible = ref<boolean>(false);
  const handelUserEdit = (row: IUserInfoItem) => {
    const {
      id,
      accountName,
      accountId,
      accountInfoId,
      userCode,
      userName,
      userUDID,
      dataChannel,
      userId,
      isReBuild,
      appCode,
    } = row;
    accountUserItem.value = {
      id,
      accountName,
      accountInfoId,
      accountId,
      userCode,
      userName,
      userUDID,
      dataChannel,
      userId,
      isReBuild,
      appCode,
    };
    createdUserVisible.value = true;
  };

  // 获取开发者账号列表
  const accountList = ref<GetV1AccountInfoApiResItem[]>([]);
  const getAccountLists = async (data: { accountName: string;}) => {
    console.log(data);
    const res = await getAccountList(data);
    accountList.value = res?.data ?? [];
  };

  // 创建
  const handleClose = () => {
    (currentInstance.refs.ruleForm as any).resetFields();
    emit('update:visible', false);
  };
  const handleCreated = () => {
    accountUserItem.value = {};
    createdUserVisible.value = true;
  };
  const handleSave = async () => {
    await (currentInstance.refs.ruleForm as any).validate();
    if (props.value.id) {
      await EditUserInfo({
        ...props.value,
        id: props.value.id,
        companyId,
      });
    } else {
      await AddUserInfo({
        ...props.value,
        companyId,
      });
    }
    ElMessage.success('操作成功！');
    emit('handleSearch');
    handleClose();
  };

  // 刷新在职状态数据
  const handleRefreshWorkStatus = (searchCb: any) => {
    return async () => {
      await UserInfoRefreshWorkState(companyId);
      ElMessage.success('操作成功！');
      searchCb();
    };
  };

  // 停用
  const disabledVisible = ref<boolean>(false);

  const handleDisClose = () => {
    (currentInstance.refs.disabledForm as any).resetFields();
    emit('update:visible', false);
  };
  const handleDisabled = (row: IUserInfoItem) => {
    disabledVisible.value = true;
    accountUserItem.value = row;
    const { data } = currentInstance.parent!;
    console.log(data);
  };
  const handleDisSave = async (id: string) => {
    await (currentInstance.refs.disabledForm as any).validate();
    await UpdateEnableUserInfo({
      id,
      isEnabled: 'NO',
      remark: props.value.remark!,
    });
    ElMessage.success('操作成功！');
    emit('handleSearch');
    handleDisClose();
  };

  // 启用
  const handleEnable = (row: IUserInfoItem, searchCb: any) => {
    ElMessageBox.confirm(`是否确认启用 [${row.userName}_${row.userCode}] ？`, '温馨提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(async () => {
      await UpdateEnableUserInfo({
        id: row.id!,
        isEnabled: 'YES',
      });
      ElMessage.success('操作成功！');
      searchCb();
    }).catch(() => {
    });
  };

  // 删除
  const handleDel = (row: IUserInfoItem, searchCb: any) => {
    ElMessageBox.confirm(`是否确认删除 [${row.userName}_${row.userCode}] 的用户账号？`,
      '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
      await DelUserInfoApi(row.id);
      ElMessage.success('操作成功！');
      // 刷新页面
      searchCb();
    }).catch(() => {
    });
  };

  // 操作日志
  const logVisible = ref<boolean>(false);
  const gridData = ref<IUserInfoLogs[]>([]);
  const tableLoading = ref(false);
  const handleLogClose = () => {
    emit('update:visible', false);
  };
  const handleShowLogs = async (row: IUserInfoItem) => {
    logVisible.value = true;
    const res = await UserInfoLogs(row.id);
    gridData.value = res?.data;
  };

  return {
    // 创建
    createdUserVisible,
    handleCreated,
    handleRefreshWorkStatus,
    handleSave,
    handleClose,

    // 停用
    disabledVisible,
    handleDisClose,
    handleDisabled,
    handleDisSave,

    // 启用
    handleEnable,

    // 删除
    handleDel,

    // 操作日志
    logVisible,
    handleShowLogs,
    handleLogClose,
    gridData,
    tableLoading,

    // 编辑
    handelUserEdit,

    accountUserItem,
    accountList,

    getAccountLists,
  };
};
